import { Step, StepValidationState } from "../../../../../interfaces/step";
import { Stepper } from "../../../../../interfaces/stepper";
import { UltimateBeneficialOwnershipReportComponent } from "projects/reg-hub-client/src/app/orders/ultimate-beneficial-ownership-report/ultimate-beneficial-ownership-report.component";
import { UltimateBeneficialOwnershipReportReviewComponent } from "projects/reg-hub-client/src/app/orders/ultimate-beneficial-ownership-report-review/ultimate-beneficial-ownership-report-review.component";

export class UltimateBeneficialOwnershipReportStepper implements Stepper {

    steps: Step[];

    constructor() {
        this.steps = [
            { title: "Details", content: UltimateBeneficialOwnershipReportComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: UltimateBeneficialOwnershipReportReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}